<template>
    <div class="tsbx">
        <div class="tsbxc">
            <div class="gritem" @click="go($event)" v-show="tp == '费用支出'">
                <div class="gileft">
                    <span>总支出</span>
                </div>
                <div class="giright">
                    <img src="../../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)" v-show="tp == '费用支出'">
                <div class="gileft">
                    <span>支出明细</span>
                </div>
                <div class="giright">
                    <img src="../../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)" v-show="tp == '收入明细'">
                <div class="gileft">
                    <span>物业费明细</span>
                </div>
                <div class="giright">
                    <img src="../../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go($event)" v-show="tp == '收入明细'">
                <div class="gileft">
                    <span>其他收入</span>
                </div>
                <div class="giright">
                    <img src="../../../assets/tsbx/you.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data() {
        return {
            tp:''
        }
    },
    created () {

    },
    updated() {
        // this.tp = this.$route.query.type
        
    },
    mounted() {
        this.tp = this.getidval('type')
        this.$emit('fatherMethod',{
            title:decodeURI(this.tp)
        })
    },
    methods: {
        getidval(name){    
            var url = window.location.href;
            console.log(url)
            let params = url.substr(url.lastIndexOf("?") + 1).split("&");
            for (let i = 0; i < params.length; i++) {
                let param = params[i];
                let key = param.split("=")[0];
                let value = param.split("=")[1];
                if (key === name) {
                return decodeURI(value) ;
                }
            }
        },
        go(event){
            var that =this
            var name = event.target.innerHTML
            if(name.indexOf('总支出') != -1){
                this.$router.push({ path: "/wyfw/wyjj/zsr", query: {type:'支出'} });
            }
            if(name.indexOf('支出明细') != -1){
                 this.$router.push({ path: "/wyfw/wyjj/zsr", query: {type:'明细'} });
            }
            if(name.indexOf('其他收入') != -1){
                 this.$router.push({ path: "/wyfw/wyjj/zsr", query: {type:'其他收入'} });
            }
            if(name.indexOf('物业费明细') != -1){
                 this.$router.push({ path: "/wyfw/wyjj/wyfmx", query: {} });
            }
        }
    },
}
</script>
<style lang="less">
    .tsbx{
        // height: 100%;
        width: 100%;
        display: flex;
        // background-color: #eeeeee;
        flex-direction: column;
        align-items: center;
        .tsbxc{
            width: calc(100% - 6%);
            .gritem{
                margin-top: 15px;
                height: 60px;
                width: 100%;
                display: flex;
                background: #fff;
                align-items: center;
                border-radius: 10px;
                justify-content: space-between;
                .gileft{
                    display: flex;
                    height: 100%;
                    align-items: center;
                    width: 50%;
                    img{
                        margin-left: 20px;
                    }
                    span{
                        margin-left: 10px;
                    }
                }
                .giright{
                    margin-right: 20px;
                    height: 100%;
                    align-items: center;
                    display: flex;
                    flex-direction:row-reverse;
                    img{
						display: block;
						height: 18px;
					}
                }
            }
        }
    }
</style>